import type { FC } from 'react';

import type { MostVisitedCompany } from '@xing-com/crate-common-graphql-types';

import { SectionContainer } from '../../../../components/section-container/section-container';
import { SimpleCompanyCardGrid } from '../../../../components/simple-company-card-grid/simple-company-card-grid';
import { useMostVisitedCompanies } from '../../../../hooks/use-most-visited-companies';
import { createSimpleCompanies } from '../../../../models/most-visited-companies';
import { ROUTES } from '../../../../routes';
import type { SimpleCompanyItem } from '../../../../types';

const LIMIT = 6;

export const MostVisitedCompaniesSection: FC = () => {
  const { data, loading } = useMostVisitedCompanies({
    limit: LIMIT,
  });

  let mostVisitedCompanies: SimpleCompanyItem[] = [];

  if (data?.mostVisitedCompanies?.collection) {
    const companies = data.mostVisitedCompanies
      .collection as MostVisitedCompany[];
    mostVisitedCompanies = createSimpleCompanies(companies);
  }

  return (
    <SectionContainer
      title="CP_MOST_VISITED_COMPANIES_TITLE"
      subtitle="CP_MOST_VISITED_COMPANIES_SUBLINE"
      linkUri={ROUTES.mostVisitedCompanies}
    >
      {mostVisitedCompanies && (
        <SimpleCompanyCardGrid
          items={mostVisitedCompanies}
          limit={LIMIT}
          loading={loading}
        />
      )}
    </SectionContainer>
  );
};
